import style from "../../assets/scss/sub/SubBgHeader.module.scss";

export function SubBgHeader({bgClassName, title}) {

  return <div className={`${style.bg} ${style[bgClassName]}`}>
    <div className={style.bgCover}></div>
    <div className={style.line}></div>
    <h2 className={style.title}>{title}</h2>
  </div>;
}